interface SidebarTabButtonProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
}

export default function SidebarTabButton({ label, active = false, onClick }: SidebarTabButtonProps) {
  return (
    <span className={`sidebar-tab-button ${active ? 'active' : ''}`}>
      <button onClick={onClick}>{label}</button>
    </span>
  );
}
